interface ElementalListContextType {
  listId?: string
  parentListId?: string
  onList: boolean
  isOwner: ComputedRef<boolean>
  isFolder: boolean
  isAll?: boolean
}

export const ElementalListContext = Symbol('ElementalListContext') as InjectionKey<ElementalListContextType>

export const useElementalListContext = (): ElementalListContextType => {
  const context = inject(ElementalListContext, {
    onList: false,
    isOwner: computed(() => false),
    isFolder: false,
  })
  return context
}
